import React from 'react';

const EmptyRecentActivity = () => {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="h-16 w-16 bg-silver-mist flex items-center justify-center mb-6" style={{ borderRadius: '16px' }}>
        <svg 
          className="h-8 w-8 text-steel" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth="1.5" 
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
          />
        </svg>
      </div>
      <div className="space-y-2 max-w-sm">
        <h3 className="text-sm font-semibold text-deep-jungle">No recent claims activity</h3>
        <p className="text-xs text-steel leading-relaxed">
          Claims activity will appear here once submissions are made
        </p>
      </div>
    </div>
  );
};

export default EmptyRecentActivity;
